import { FiEdit2 } from 'react-icons/fi';
import { formatDate } from '../../../../utlis';
import MyTable from '../../../../components/MyTable';


const ClassesTable = ({ data, onEditClass, pageSize, onPageSizeChange }) => {
  // Transform data to ensure consistent field names
  const transformedData = data.map((classItem) => ({
    id: classItem.class_id || classItem.id || '',
    description: classItem.description || '',
    faculty_name: classItem.faculty_name || '',
    technology_name: classItem.technology_name || '',
    start_date: classItem.start_date || '',
    end_date: classItem.end_date || '',
    min_enrollment: classItem.min_enrollment || 0,
    max_enrollment: classItem.max_enrollment || 0,
    status: classItem.status || '',
    created_by: classItem.created_by || '',
    created: classItem.created || '',
    updated_by: classItem.updated_by || '',
    updated: classItem.updated || '',
  }));

  const columns = [
    {
      name: 'id',
      label: 'ID',
      options: {
        display: false,
      },
    },
    {
      name: 'description',
      label: 'Class Name',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData[0];
          return (
            <h3
              onClick={() => onEditClass(id)}
              className="text-base font-bold text-auxiliary-800 cursor-pointer hover:underline"
            >
              {value || 'N/A'}
            </h3>
          );
        },
      },
    },
    {
      name: 'faculty_name',
      label: 'Faculty Name',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <p className="text-text-hint">{value || 'N/A'}</p>
        ),
      },
    },
    {
      name: 'technology_name',
      label: 'Technology',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || 'N/A',
      },
    },
    {
      name: 'start_date',
      label: 'Start Date',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (value ? formatDate(value) : 'N/A'),
      },
    },
    {
      name: 'end_date',
      label: 'End Date',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (value ? formatDate(value) : 'N/A'),
      },
    },
    {
      name: 'min_enrollment',
      label: 'Min Enrollment',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="bg-secondary-50 text-success-800 py-1 px-3 rounded-full">
            {value || '0'}
          </span>
        ),
      },
    },
    {
      name: 'max_enrollment',
      label: 'Max Enrollment',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="bg-secondary-100 text-secondary-800 py-1 px-3 rounded-full">
            {value || '0'}
          </span>
        ),
      },
    },
    {
      name: 'created_by',
      label: 'Created By',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || 'N/A',
      },
    },
    {
      name: 'created',
      label: 'Date Created',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (value ? formatDate(value) : 'N/A'),
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="font-bold">{value || 'N/A'}</span>
        ),
      },
    },
    {
      name: 'actions',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const classId = tableMeta.rowData[0];
          return (
            <button
              onClick={() => onEditClass(classId)}
              className="p-2 hover:bg-gray-200 rounded-full"
              title="Edit Class"
            >
              <FiEdit2 size={16} className="text-secondary-700" />
            </button>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'standard',
    rowsPerPage: pageSize,
    rowsPerPageOptions: [5, 10, 15, 20, 50],
    onChangeRowsPerPage: (numberOfRows) => onPageSizeChange(numberOfRows),
    selectableRows: 'none',
    elevation: 0,
    download: true,
    print: true,
    search: false,
    viewColumns: true,
    filter: true,
  };

  return (
    <div className="w-full overflow-x">
      <MyTable
        title=""
        data={transformedData}
        columns={columns}
        options={options}
      />
    </div>
  );
};

export default ClassesTable;
